import React from "react";
import {CustomDivider, CustomGrid} from "../../components/custom-common";
import {Button, Icon} from "semantic-ui-react";

export const MfaMethodItem = ({
  title,
  description,
  createdTime,
  ableToBeReconfigured = true,
  onClickReconfigurable
}) => {

  if(ableToBeReconfigured && !onClickReconfigurable) {
    throw new Error("Missing onClickReconfigurable")
  }

  return (
    <div className={'mfaSectionDivider'}>
      <CustomGrid>
        <CustomGrid.Row columns={ableToBeReconfigured ? 2 : 1}>
          <CustomGrid.Column floated="left">
              <div className={"neutral700Text"}>
                <b>{title}</b>
              </div>
              <CustomDivider smaller hidden/>
              <div className={'smaller neutral700Text'}>
                <span>
                  <b>{description}</b>
                </span>{" "}
                is configured for your account.
              </div>
              <CustomDivider smaller hidden/>

            <div className={'smaller neutral700Text'}>
              <Icon
                name="checkmark"
                size="small"
                className="mfaVerifiedIcon"
              />{" "}
              Date added {createdTime}
            </div>
          </CustomGrid.Column>
          {ableToBeReconfigured && (
            <CustomGrid.Column
              floated="right"
              className={'mfaFlexEnd'}
            >
              <Button basic compact
                primary
                onClick={onClickReconfigurable}
              >
                Re-configure{" "}
                <Icon
                  name={"pencil"}
                  floated={"right"}
                />
              </Button>
            </CustomGrid.Column>
          )}
        </CustomGrid.Row>
      </CustomGrid>
    </div>
  )
}
